import { Text } from '@querodelivery/uni-react';
import type { ReactNode } from 'react';
import styles from './metric-tile.module.scss';

interface MetricTileProps {
  label: string;
  children: ReactNode;
}

export function MetricTile({ label, children }: MetricTileProps) {
  return (
    <div className={styles.tile}>
      <Text
        as="span"
        fontSize="xs"
        fontWeight="medium"
        lineHeight="lg"
        tone="supporting"
        truncate
      >
        {label}
      </Text>
      {children}
    </div>
  );
}
